// extracted by mini-css-extract-plugin
module.exports = {"graph":"TotalsGraph_graph__3oTQ8","playButton":"TotalsGraph_playButton__mCgf2"};